<sn-player
  #playerElement
  [width]="width"
  [height]="height"
  [caption]="caption"
  [aspectRatio]="aspectRatio"
  [state]="state$ | async"
>
  <div #playerContent snPlayerContent class="bosch-player"></div>
  <div snPlayerFooter class="sn-video-player__footer">
    <fs-timeline
      *ngIf="timeline && src.record && alwaysOn"
      class="videoPlayerTimeline"
      #recordingTimeline
      [currentTime]="time"
      [currentDate]="date"
      [height]="56"
      [fullscreen]="fullscreen"
      (moveCursor)="moveCursor($event)"
      [timelineDefinition]="timeline"
    >
    </fs-timeline>
    <div class="timelineControls" *ngIf="timeline && showCalendar && src.record">
      <mat-calendar
        class="calendar availability"
        #calendar
        [(selected)]="date"
        [dateFilter]="hasRecordings"
      ></mat-calendar>
    </div>
    <ng-content></ng-content>
  </div>
</sn-player>
